export default "__VITE_ASSET__d7dfad1e__"